import React from 'react';
import Titulo from '../comum/Titulo';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { showSuccessMsg } from '../../util/messagesUtil';
import { bindActionCreators } from 'redux';
import cadastrarConfiguracaoEncomenda from '../../actions/empresa/cadastrarConfiguracaoEncomenda';
import buscarConfiguracaoEncomenda from '../../actions/empresa/buscarConfiguracaoEncomenda';
import {
    maxValueMonetario,
    renderFieldMonetarioLabelEncima,
    renderFieldPercentLabelEncima,
    maxValueMonetarioPercentual,
    required,
} from '../../util/inputs';

const SectionCard = ({ icon, title, subtitle, children }) => (
    <div className="vx-config-card">
        <div className="vx-config-card-header">
            <i className="material-icons">{icon}</i>
            <div className="vx-config-card-header-text">
                <h6>{title}</h6>
                {subtitle && <small>{subtitle}</small>}
            </div>
        </div>
        <div className="vx-config-card-body">
            {children}
        </div>
    </div>
);

const renderToggle = ({ input }) => (
    <label className="vx-switch" style={{ cursor: 'pointer', flexShrink: 0 }}>
        <input {...input} type="checkbox" />
        <span className="vx-switch-slider" />
    </label>
);

export class PainelConfiguracaoEncomendas extends React.Component {
    constructor(props) {
        super(props);
        this.salvar = this.salvar.bind(this);
    }

    componentDidMount() {
        if (this.props.empresaSelecionada.id) {
            this.props.buscarConfiguracaoEncomenda(this.props.empresaSelecionada.id);
        }
    }

    montarParametros() {
        return {
            id: this.props.id,
            habilitadoPrecoKg: this.props.habilitadoPrecoKg,
            precoKg: this.props.habilitadoPrecoKg ? this.props.precoKg.replace('R$', '') : null,
            habilitadoPrecoFixoMaisValorKg: this.props.habilitadoPrecoFixoMaisValorKg,
            precoFixo: this.props.habilitadoPrecoFixoMaisValorKg ? this.props.precoFixo.replace('R$', '') : null,
            valorKg: this.props.habilitadoPrecoFixoMaisValorKg ? this.props.valorKg.replace('R$', '') : null,
            habilitadoPrecoMetroCubico: this.props.habilitadoPrecoMetroCubico,
            precoMetroCubico: this.props.habilitadoPrecoMetroCubico ? this.props.precoMetroCubico.replace('R$', '') : null,
            habilitadoTaxaSeguro: this.props.habilitadoTaxaSeguro,
            taxaSeguro: this.props.habilitadoTaxaSeguro ? this.props.taxaSeguro.replace('R$', '') : null,
            mensagem: this.props.mensagem,
        };
    }

    salvar() {
        this.props.cadastrarConfiguracaoEncomenda(
            this.props.empresaSelecionada.id,
            this.montarParametros()
        ).then(() => {
            showSuccessMsg('Configuração salva com sucesso');
        });
    }

    render() {
        const { invalid, pristine } = this.props;

        return (
            <div className="container-padrao">
                <Titulo texto="Configuração de Encomendas" urlRetorno="/menu-encomendas" />

                <form className="vx-config-page">

                    {/* ── Cobrança ── */}
                    <SectionCard icon="local_shipping" title="Tipo de Cobrança" subtitle="Defina a regra de precificação das encomendas">

                        {/* Preço por Kg */}
                        <div className="vx-toggle-row">
                            <div className="vx-toggle-info">
                                <div className="vx-toggle-info-title">Preço por Kg</div>
                                <div className="vx-toggle-info-desc">Cobra um valor fixo por quilograma da encomenda</div>
                            </div>
                            <Field name="habilitadoPrecoKg" type="checkbox" component={renderToggle} />
                        </div>
                        {this.props.habilitadoPrecoKg && (
                            <div className="vx-toggle-sub" style={{ maxWidth: 240 }}>
                                <Field
                                    name="precoKg"
                                    validate={[maxValueMonetario, required]}
                                    component={renderFieldMonetarioLabelEncima}
                                    label="Preço do Kg:"
                                />
                            </div>
                        )}

                        {/* Preço Fixo + Kg */}
                        <div className="vx-toggle-row">
                            <div className="vx-toggle-info">
                                <div className="vx-toggle-info-title">Preço Fixo + Preço por Kg</div>
                                <div className="vx-toggle-info-desc">Cobra uma taxa fixa de abertura mais um valor por Kg adicional</div>
                            </div>
                            <Field name="habilitadoPrecoFixoMaisValorKg" type="checkbox" component={renderToggle} />
                        </div>
                        {this.props.habilitadoPrecoFixoMaisValorKg && (
                            <div className="vx-toggle-sub">
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, maxWidth: 500 }}>
                                    <Field
                                        name="precoFixo"
                                        validate={[maxValueMonetario, required]}
                                        component={renderFieldMonetarioLabelEncima}
                                        label="Taxa fixa:"
                                    />
                                    <Field
                                        name="valorKg"
                                        validate={[maxValueMonetario, required]}
                                        component={renderFieldMonetarioLabelEncima}
                                        label="Preço do Kg adicional:"
                                    />
                                </div>
                            </div>
                        )}

                        {/* Metro Cúbico */}
                        <div className="vx-toggle-row">
                            <div className="vx-toggle-info">
                                <div className="vx-toggle-info-title">Preço por Metro Cúbico (M³)</div>
                                <div className="vx-toggle-info-desc">Cobra com base no volume da encomenda em metros cúbicos</div>
                            </div>
                            <Field name="habilitadoPrecoMetroCubico" type="checkbox" component={renderToggle} />
                        </div>
                        {this.props.habilitadoPrecoMetroCubico && (
                            <div className="vx-toggle-sub" style={{ maxWidth: 240 }}>
                                <Field
                                    name="precoMetroCubico"
                                    validate={[maxValueMonetario, required]}
                                    component={renderFieldMonetarioLabelEncima}
                                    label="Preço por M³:"
                                />
                            </div>
                        )}
                    </SectionCard>

                    {/* ── Taxa de Seguro ── */}
                    <SectionCard icon="security" title="Taxa de Seguro" subtitle="Percentual sobre o valor declarado ou nota fiscal">
                        <div className="vx-toggle-row">
                            <div className="vx-toggle-info">
                                <div className="vx-toggle-info-title">Habilitar Taxa de Seguro</div>
                                <div className="vx-toggle-info-desc">Adiciona um percentual de seguro ao valor do pedido</div>
                            </div>
                            <Field name="habilitadoTaxaSeguro" type="checkbox" component={renderToggle} />
                        </div>
                        {this.props.habilitadoTaxaSeguro && (
                            <div className="vx-toggle-sub">
                                <div style={{ maxWidth: 240, marginBottom: 10 }}>
                                    <Field
                                        name="taxaSeguro"
                                        validate={[maxValueMonetarioPercentual, required]}
                                        component={renderFieldPercentLabelEncima}
                                        label="Taxa do Seguro (%):"
                                        maxLength={5}
                                    />
                                </div>
                                <p style={{ fontSize: 12, color: '#888', margin: 0, lineHeight: 1.5 }}>
                                    <i className="material-icons" style={{ fontSize: 13, verticalAlign: 'middle', marginRight: 4 }}>info_outline</i>
                                    O seguro será calculado sobre o valor da nota fiscal ou do valor declarado e adicionado ao total do pedido.
                                </p>
                            </div>
                        )}
                    </SectionCard>

                    {/* ── Mensagem da Via Remetente ── */}
                    <SectionCard icon="description" title="Mensagem da Via Remetente" subtitle="Texto impresso na via do remetente (até 2000 caracteres)">
                        <Field
                            id="mensagemEncomenda"
                            name="mensagem"
                            component="textarea"
                            className="form-control"
                            style={{ minHeight: 110, resize: 'vertical', fontSize: 13 }}
                            placeholder="Escreva a mensagem que será impressa na via do remetente..."
                            maxLength={2000}
                        />
                        {this.props.mensagem && (
                            <div style={{ fontSize: 11, color: '#aaa', marginTop: 4, textAlign: 'right' }}>
                                {(this.props.mensagem || '').length} / 2000
                            </div>
                        )}
                    </SectionCard>

                    {/* ── Save bar ── */}
                    <div className="vx-config-save-bar">
                        <span className="vx-config-save-hint">
                            <i className="material-icons">info_outline</i>
                            Apenas uma modalidade de cobrança deve ser habilitada por vez
                        </span>
                        <button
                            type="button"
                            className="btn btn-laranja vx-config-save-btn"
                            onClick={this.salvar}
                            disabled={invalid || pristine}
                        >
                            <i className="material-icons">save</i>
                            Salvar Configuração
                        </button>
                    </div>

                </form>
            </div>
        );
    }
}

export const mapStateToProps = state => ({
    initialValues: {
        id: state.configuracaoEncomenda.id,
        habilitadoPrecoKg: state.configuracaoEncomenda.habilitadoPrecoKg,
        precoKg: state.configuracaoEncomenda.precoKg,
        habilitadoPrecoFixoMaisValorKg: state.configuracaoEncomenda.habilitadoPrecoFixoMaisValorKg,
        valorKg: state.configuracaoEncomenda.valorKg,
        precoFixo: state.configuracaoEncomenda.precoFixo,
        habilitadoPrecoMetroCubico: state.configuracaoEncomenda.habilitadoPrecoMetroCubico,
        precoMetroCubico: state.configuracaoEncomenda.precoMetroCubico,
        habilitadoTaxaSeguro: state.configuracaoEncomenda.habilitadoTaxaSeguro,
        taxaSeguro: state.configuracaoEncomenda.taxaSeguro,
        mensagem: state.configuracaoEncomenda.mensagem,
    },
    empresaSelecionada: state.empresaSelecionada,
    habilitadoPrecoKg: formValueSelector('formularioCadastroConfiguracaoEncomenda')(state, 'habilitadoPrecoKg'),
    precoKg: formValueSelector('formularioCadastroConfiguracaoEncomenda')(state, 'precoKg'),
    habilitadoPrecoFixoMaisValorKg: formValueSelector('formularioCadastroConfiguracaoEncomenda')(state, 'habilitadoPrecoFixoMaisValorKg'),
    valorKg: formValueSelector('formularioCadastroConfiguracaoEncomenda')(state, 'valorKg'),
    precoFixo: formValueSelector('formularioCadastroConfiguracaoEncomenda')(state, 'precoFixo'),
    habilitadoTaxaSeguro: formValueSelector('formularioCadastroConfiguracaoEncomenda')(state, 'habilitadoTaxaSeguro'),
    habilitadoPrecoMetroCubico: formValueSelector('formularioCadastroConfiguracaoEncomenda')(state, 'habilitadoPrecoMetroCubico'),
    precoMetroCubico: formValueSelector('formularioCadastroConfiguracaoEncomenda')(state, 'precoMetroCubico'),
    taxaSeguro: formValueSelector('formularioCadastroConfiguracaoEncomenda')(state, 'taxaSeguro'),
    mensagem: formValueSelector('formularioCadastroConfiguracaoEncomenda')(state, 'mensagem'),
    id: state.configuracaoEncomenda.id,
});

export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        cadastrarConfiguracaoEncomenda,
        buscarConfiguracaoEncomenda,
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioCadastroConfiguracaoEncomenda',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(PainelConfiguracaoEncomendas));
